import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=4a83089d&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=js&"
export * from "./Forgot.vue?vue&type=script&lang=js&"
import style0 from "./AuthEmail.scss?vue&type=style&index=0&id=4a83089d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a83089d",
  null
  
)

export default component.exports